module.exports = __webpack_public_path__ + "img/enable-step.255a6972.svg";